export const indexColumns = [
  {
    type: 'name',
    value: 'name',
    label: 'Name',
    isSortable: true,
  },
  {
    type: 'numOfLicenses',
    value: 'numOfLicenses',
    label: 'Number of license(s)',
    isSortable: true,
  },
  {
    type: 'numOfVideos',
    value: 'numOfVideos',
    label: 'Number of video(s)',
    isSortable: true,
  },
  {
    type: 'actions',
    value: null,
    label: 'Actions',
    isSortable: false,
  },
];

export const editorLicensesColumns = [
  {
    type: 'name',
    value: 'title',
    label: 'Name',
  },
  {
    type: 'numOfVideos',
    value: 'numOfVideos',
    label: 'Number of video(s)',
  },
  {
    type: 'actions',
    value: null,
    label: 'Actions',
  },
];

const sharedConfig = {
  clearable: true,
  variant: 'outlined',
  // DEV NOTE: must be 'false' for 'v-autocomplete'
  hideDetails: true,
};

export const filterConfig = [
  {
    name: 'keyword',
    controlType: 'text',
    label: 'Search',
    prependInnerIcon: 'mdi-magnify',
    ...sharedConfig
  },
  {
    // DEV NOTE: due to bug in 'autocmplete' temporary use 'autocomplete'
    name: 'country',
    controlType: 'autocomplete',
    label: 'Countries',
    itemTitle: 'label',
    itemValue: 'id',
    items: [],
    ...sharedConfig,
    hideDetails: true
  },
  {
    name: 'language',
    controlType: 'autocomplete',
    label: 'Language',
    itemTitle: 'label',
    itemValue: 'id',
    items: [],
    ...sharedConfig,
    hideDetails: false
  },
];

export default { indexColumns, editorLicensesColumns, filterConfig };
